import type { NavigationProp } from '@react-navigation/native';
import { useNavigation } from '@react-navigation/native';

import type { AppParam } from '@/navigation/types/navigation';

export const useAppNavigation = () => useNavigation<NavigationProp<AppParam>>();
